const VALID_SCOPES = {
  pte: new Set(['full', 'sectional', 'question-type']),
  ielts: new Set(['full', 'sectional']),
};

export function slugifyTestName(value) {
  return String(value || '')
    .trim()
    .toLowerCase()
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '') || 'mock-test';
}

export function buildMockTestPath({ exam, scope, id, name }) {
  const normalizedExam = String(exam || '').toLowerCase();
  const normalizedScope = String(scope || '').toLowerCase();
  const numericId = Number(id);
  if (!VALID_SCOPES[normalizedExam]?.has(normalizedScope) || !Number.isInteger(numericId) || numericId <= 0) {
    return null;
  }
  return `/${normalizedExam}/mock-tests/${normalizedScope}/${numericId}-${slugifyTestName(name)}`;
}

export function parseTestKey(testKey) {
  const match = String(testKey || '').match(/^(\d+)(?:-(.*))?$/);
  if (!match) return null;
  const id = Number(match[1]);
  if (!Number.isInteger(id) || id <= 0) return null;
  return { id, slug: match[2] || '' };
}

export function getSharedRouteAction(resolved) {
  if (!resolved) return 'loading';
  return resolved.access?.canStart || resolved.access?.canResume ? 'launch' : 'locked';
}

export function getInternalReturnPath(location) {
  const pathname = String(location?.pathname || '/');
  if (!pathname.startsWith('/') || pathname.startsWith('//')) return '/';
  return `${pathname}${location?.search || ''}${location?.hash || ''}`;
}

function launchGrantKey({ exam, scope, id }) {
  return `swiftuni:test-launch:${exam}:${scope}:${Number(id)}`;
}

export function storeLaunchGrant(identity, token) {
  if (!token || typeof window === 'undefined') return;
  window.sessionStorage.setItem(launchGrantKey(identity), token);
}

export function getStoredLaunchGrant(identity) {
  if (typeof window === 'undefined') return null;
  return window.sessionStorage.getItem(launchGrantKey(identity));
}
